"use client";

import { QueryClient, QueryClientProvider, isServer } from "@tanstack/react-query";

type Props = {
  children?: React.ReactNode;
};

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}

export const queryClient = getQueryClient();

export default function QueryProvider({ children }: Props) {
  return <QueryClientProvider client={getQueryClient()}>{children}</QueryClientProvider>;
}
